import { Inject, Injectable, Injector, LOCALE_ID } from '@angular/core';
import { Observable } from 'rxjs';
import { IDocumentTypesList } from '@carm/_core';
import { IKeyValue } from '@carm/_utils/models';
import { BaseApiService } from '@carm/_core/baseapi.service';
import { map } from 'rxjs/operators';
import { DocumentGroups, IUploadedDocument } from '../models';
import { environment } from 'src/environments/environment';
import { IUploadedDocumentsList } from '../models/document-types-list.model';
import { HttpParams } from '@angular/common/http';
import {
  mapToKeyValue,
  mapToUploadedDocuments,
} from '../models/document.converters';
import { CarmBlob } from '../models/carm-blob.model';

@Injectable()
export class DocumentService extends BaseApiService {
  constructor(
    protected injector: Injector,
    @Inject(LOCALE_ID) protected localeId: string
  ) {
    super(injector);
  }

  get documentsBPUrl(): string {
    return `${this.endPointBP}/documents`;
  }

  get documentsUrl(): string {
    return `${environment.baseApiUrls}/documents`;
  }

  public getDocuments(
    caseNumber: string,
    documentGroup: DocumentGroups,
    source: 'ATTACHMENTS' | 'DECISION'
  ): Observable<IUploadedDocument[]> {
    const endpoint = `${this.documentsBPUrl}/case/${caseNumber}/group/${documentGroup.toString()}/list`;

    const params = new HttpParams().set('source', source);
    return this.httpAuthGet<IUploadedDocumentsList>(
      endpoint,
      params
    ).pipe(
      map(response =>
        response.documentList.map(document =>
          mapToUploadedDocuments(document, this.localeId)
        )
      )
    );
  }

  public getDocumentTypes(
    documentGroup: DocumentGroups
  ): Observable<IKeyValue[]> {
    const endpoint = `${this.documentsUrl}/group/${documentGroup.toString()}/types`;
    return this.httpAuthGet<IDocumentTypesList>(endpoint).pipe(
      map(documentTypes => {
        return mapToKeyValue(documentTypes, this.localeId);
      })
    );
  }

  public getDocument(
    caseNumber: string,
    documentGroup: DocumentGroups,
    documentId: string
  ): Observable<CarmBlob> {

    const endPoint = `${this.documentsBPUrl}/case/${caseNumber}/group/${documentGroup.toString()}/document/${documentId}/download`;
    return this.httpAuthDownloadFile(endPoint);
  }

  public getUploadUrl(caseNumber: string, documentGroup: DocumentGroups): string {
    return `${this.documentsBPUrl}/case/${caseNumber}/group/${documentGroup.toString()}/upload`;
  }
}
